import { AwsRum } from "aws-rum-web";

try {
    const APPLICATION_ID = "599b8f61-944c-47ba-9ac9-0bcb585f030d";
    const APPLICATION_VERSION = __APP_VERSION__;
    const APPLICATION_REGION = "us-west-2";

    new AwsRum(APPLICATION_ID, APPLICATION_VERSION, APPLICATION_REGION, {
        sessionSampleRate: 1,
        endpoint: "https://dataplane.rum.us-west-2.amazonaws.com",
        telemetries: ["performance", "errors", "http"],
        allowCookies: true,
        enableXRay: false,
        signing: false, // We are sending unsigned requests (user is not logged in)
    });
} catch (error) {
    // Ignore errors thrown during CloudWatch RUM web client initialization
}
